module.exports = __webpack_public_path__ + "img/flower_leaf_38.0bd92bdf.png";